import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import AdministrationPage from '../containers/AdministrationPage';

class AdminCategoriesListPage extends Component {
  constructor(props) {
    super(props);
    this.queryInputRef = React.createRef();

    this.state = {
      q: '',
    };

    this.onChangeQuery = this.onChangeQuery.bind(this);
    this.onClearQueryClick = this.onClearQueryClick.bind(this);
  }

  componentDidMount() {
    this.props.getCategories();
  }

  onChangeQuery(event) {
    event.preventDefault();
    event.persist();
    this.setState({ q: event.target.value || '' });
  };

  onClearQueryClick() {
    this.setState({ q: '' });
    this.queryInputRef.current.focus();
  };

  render() {
    const filteredCategories = this.props.categories
    .filter(category => category.name.toLocaleLowerCase().includes(this.state.q.trim().toLocaleLowerCase()))
    .sort((a, b) => {
      if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
        return 1;
      }

      if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
        return -1;
      }

      return 0;
    });

    return (
      <React.Fragment>
          <Helmet>
            <title>Categorie - Smart Gaming</title>
          </Helmet>
          <AdministrationPage>
            <div className="w-full max-w-lg relative">
              <h1 className="font-black font-serif mb-8 text-3xl tracking-tight block text-black">Categorie</h1>
            </div>
            <div className="w-full mx-auto">
              <div className="bg-white shadow-md rounded my-6">
                <table className="text-left w-full border-collapse">
                  <thead>
                    <tr>
                      <th colSpan="3" className="w-16 py-4 px-6 bg-gray-100 font-bold text-sm text-gray-500 border-b border-gray-300">
                        <div className="flex relative">
                          <Link to="/admin/categories/create" className="absolute h-full flex justify-center items-center cursor-pointer bg-blue-700 hover:bg-blue-900 text-white py-2 px-4 top-0 left-0 rounded rounded-r-none">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="#FFFFFF" d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>
                          </Link>
                          <input
                            className="bg-gray-200 appearance-none border-2 border-gray-200 rounded rounded-l-none w-full py-2 px-4 pl-16 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500"
                            id="q"
                            type="text"
                            placeholder="Cerca"
                            ref={this.queryInputRef}
                            value={this.state.q}
                            onChange={this.onChangeQuery} />
                            <button type="button" onClick={this.onClearQueryClick} className="absolute inset-y-0 right-0 flex items-center px-4 cursor-pointer text-gray-700">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                                <path fill="#4a5568" d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/>
                              </svg>
                            </button>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      filteredCategories
                        .map(category => {
                          return (
                            <tr key={category.id} className="hover:bg-gray-200">
                              <td className="w-full py-4 px-6 border-b border-gray-300">
                                <Link to={`/admin/categories/${category.id}`}>
                                  <span className="font-bold">{ category.name }</span>
                                </Link>
                              </td>
                            </tr>
                          );
                        })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </AdministrationPage>
      </React.Fragment>
    );
  }
}

export default AdminCategoriesListPage;
